export default "__VITE_ASSET__mXdy7AGJ__"